import { useMystudioNotificationsV4 } from "../../../Common/api/v4/hooks";

const useAlarmNewCountREST = (enabled: boolean = true) => {
    const query = useMystudioNotificationsV4({ page: 1, limit: 1 }, enabled);

    return {
        alarmNewCountData: query.data?.data?.unreadCount || 0,
        alarmNewCountIsLoading: query.isLoading,
        alarmNewCountError: query.error,
        alarmNewCountRefetch: query.refetch,
    };
};

export default useAlarmNewCountREST;
